module.exports = __webpack_public_path__ + "img/Lab_Book_Icon_Export_PDF.ac276955.svg";